// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Microdata__hidden--2bKV0"};